import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="text-4xl font-bold mb-6">{t('privacy.title')}</h1>

      <div className="prose dark:prose-invert space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('privacy.section1Title')}
          </h2>
          <p className="text-raya-text-primary/90 font-medium mb-2">
            {t('privacy.section1Intro')}
          </p>
          <ul className="list-disc list-inside space-y-2 text-raya-text-primary/90 font-medium">
            <li>
              <strong>{t('privacy.personalDataTitle')}:</strong> {t('privacy.personalData')}
            </li>
            <li>
              <strong>{t('privacy.deviceDataTitle')}:</strong> {t('privacy.deviceData')}
            </li>
            <li>
              <strong>{t('privacy.transactionDataTitle')}:</strong> {t('privacy.transactionData')}
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('privacy.section2Title')}
          </h2>
          <ul className="list-disc list-inside space-y-2 text-raya-text-primary/90 font-medium">
            <li>{t('privacy.use1')}</li>
            <li>{t('privacy.use2')}</li>
            <li>{t('privacy.use3')}</li>
            <li>{t('privacy.use4')}</li>
            <li>{t('privacy.use5')}</li>
            <li>{t('privacy.use6')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('privacy.section3Title')}
          </h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('privacy.section3Intro')}
          </p>
          <ul className="list-disc list-inside space-y-2 text-raya-text-primary/90 font-medium mt-2">
            <li>{t('privacy.share1')}</li>
            <li>{t('privacy.share2')}</li>
            <li>{t('privacy.share3')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('privacy.section4Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('privacy.section4Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('privacy.section5Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('privacy.section5Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('privacy.section6Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('privacy.section6Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('privacy.section7Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('privacy.section7Text')}
          </p>
        </section>
      </div>
    </div>
  );
}
